import { Injectable } from '@angular/core';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import {
  IMenuItem,
  IMenuItemPermissions,
  PluginInjectorApplicationPlugin,
} from 'core-client/api';
import { BehaviorSubject } from 'rxjs';

// Not yet in the DOM lib's standard typings.
interface BeforeInstallPromptEvent extends Event {
  readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
  prompt(): Promise<void>;
}

@Injectable({
  providedIn: 'root',
})
export class PwaInstallService {
  private navbarMenuItem!: IMenuItem;
  private readonly navbarMenuTitle: string = 'INSTALL_APP';
  private readonly pluginModule: string = 'PWA_INSTALL';
  private readonly menuItemPermissions: IMenuItemPermissions = {};

  private readonly canInstall$ = new BehaviorSubject<boolean>(false);
  private deferredPrompt: BeforeInstallPromptEvent | null = null;

  constructor() {
    window.addEventListener('beforeinstallprompt', (event: Event) => {
      event.preventDefault();
      this.deferredPrompt = event as BeforeInstallPromptEvent;
      this.canInstall$.next(true);
    });
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
      this.canInstall$.next(false);
    });
  }

  getNavbarMenuItem(
    pluginConfig: PluginInjectorApplicationPlugin.IApplicationPlugin,
    menu: IMenuItem[],
    primaryEnabled: boolean,
    secondaryEnabled: boolean,
  ): IMenuItem[] {
    const menuExist = menu.some(
      (item: IMenuItem) =>
        item.nameIdentifier.toLowerCase() === this.navbarMenuTitle.toLowerCase(),
    );

    this.navbarMenuItem = {
      pluginId: pluginConfig._id,
      pluginName: pluginConfig.name,
      pluginModule: this.pluginModule,
      nameIdentifier: this.navbarMenuTitle,
      accessRights: [],
      primary: { enabled: primaryEnabled, position: menu.length + 1 },
      secondary: { enabled: secondaryEnabled, position: menu.length + 1 },
      strictMode: true,
      headerSortOrder: 65,
      icon: faDownload,
      dropdown: false,
      disabled: new BehaviorSubject(false),
      visible$: this.canInstall$,
      callback: async () => {
        if (!this.deferredPrompt) return;
        await this.deferredPrompt.prompt();
        await this.deferredPrompt.userChoice;
        this.deferredPrompt = null;
      },
    };

    if (!menuExist) {
      menu.push(this.navbarMenuItem);
    }

    return menu;
  }

  getMenuItemPermissions(): IMenuItemPermissions {
    return this.menuItemPermissions;
  }
}